import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Truck, Package, ClipboardList, LogOut, Activity } from "lucide-react";
import api from "../../lib/api";
import { toast } from "sonner";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_c129d2ac-2209-4214-9ac4-af6d02f0e7d1/artifacts/e10f2m7m_hf_20260429_103436_b903d0ed-1980-49ff-95c4-cf93c75881ec.png";

export default function DriverLayout() {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const load = async () => {
    try {
      const { data } = await api.get("/driver/me");
      setMe(data);
    } catch (e) {
      localStorage.removeItem("jow_token");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("jow_token")) {
      setLoading(false);
      return;
    }
    load();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-jow-cream flex items-center justify-center label-overline text-jow-navy/55">
        Loading driver panel…
      </div>
    );
  }

  if (!me) return <Navigate to="/login?next=/driver/dashboard&as=driver" replace />;

  const signOut = () => {
    localStorage.removeItem("jow_token");
    toast.success("Signed out.");
    navigate("/");
  };

  const tabs = [
    { to: "/driver/dashboard", label: "Dashboard", Icon: Activity, testid: "dt-dashboard", end: true },
    { to: "/driver/inventory", label: "Inventory", Icon: Package, testid: "dt-inventory" },
    { to: "/driver/orders", label: "Orders", Icon: ClipboardList, testid: "dt-orders" },
  ];

  return (
    <div className="min-h-screen bg-jow-cream flex flex-col" data-testid="driver-shell">
      <header className="bg-jow-navy text-jow-cream sticky top-0 z-30">
        <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="JOW" className="h-8 w-8" />
            <div className="leading-tight">
              <p className="font-display text-sm">Driver Panel</p>
              <p className="label-overline text-jow-gold text-[9px]">
                {me.rikshaw?.code} · {me.driver?.name}
              </p>
            </div>
          </div>
          <button onClick={signOut} className="label-overline text-[10px] text-jow-cream/75 flex items-center gap-1" data-testid="driver-signout">
            <LogOut size={13} /> Sign out
          </button>
        </div>
        <nav className="bg-jow-navy/90 border-t border-jow-cream/10">
          <div className="max-w-4xl mx-auto px-2 flex">
            {tabs.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                data-testid={t.testid}
                className={({ isActive }) =>
                  `flex-1 inline-flex items-center justify-center gap-2 py-3 text-[11px] uppercase tracking-widest transition-colors ${
                    isActive ? "text-jow-gold border-b-2 border-jow-gold" : "text-jow-cream/75 hover:text-jow-cream"
                  }`
                }
              >
                <t.Icon size={13} /> {t.label}
              </NavLink>
            ))}
          </div>
        </nav>
      </header>

      <main className="flex-1 max-w-4xl w-full mx-auto px-4 py-6">
        <Outlet context={{ me, refresh: load }} />
      </main>
    </div>
  );
}
